import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Sends a GA4 page_view on every SPA route change (initial load included —
// gtag config has send_page_view:false so pages are never double-counted).
export const GaTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);
  return null;
};
